export const defaultVennDiagramValue = () => {
  return {
    styles: {
      width: 600,
      height: 600,
      border_color: "#2C7DA0",
      bg_color: "#faf9f9",
      glow_color: "#ffb600",
    },
    properties: [],
  };
};

export const defaultVennDiagramPropertyValue = () => {
  return {
    x: 50,
    y: 40,
    is_draggable: false,
    clipart: null,
    drag_on: null,
    text : null,
    text_styles : { border_color: "#00b4d8", font_color: "#000" }
  };
};
